import { textFieldPropsSchema } from '../component-catalog.js';
export const textFieldDefinition = {
    type: 'TextField',
    category: 'interactive',
    propsSchema: textFieldPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Single-line text input. Props: value?, placeholder?, label?.',
};
//# sourceMappingURL=TextField.js.map